import React, { useState } from 'react';
import { Stack, Typography } from "@mui/material";
import { DeleteIcone } from "../../../UI/Icons";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomTextField } from '../../../TextField';
import { EditIcone } from "../../../UI/Icons";

const MilestoneHeader = ({ 
  name, 
  setName, 
  error, 
  errorText, 
  handleNameKeyDown, 
  handleDelete, 
  isEditable 
}) => {
  const isMobile = useResponsive("down", "md");
  const [isEditing, setIsEditing] = useState(false);
  
  const handleNameChange = (e) => {
    const value = e.target.value;
    if (value.length > 30) {
      setName(value, "Maximum 30 characters allowed", true);
    } else {
      setName(value, "", false);
    }
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleNameKeyDown(e);
      setIsEditing(false);
    }
  };

  const handleBlur = (e) => {
    handleNameKeyDown(e);
    setIsEditing(false);
  };

  return (
    <div className="edit-worklog-title">
      <Stack direction="row" justifyContent="space-between">
        <div style={{ display: "flex", alignItems: "center" }}>
          {isEditing ? (
            <CustomTextField
              variant="standard"
              // sx={{ flexGrow: 1 }}
              onChange={handleNameChange}
              onKeyDown={handleKeyDown}
              onBlur={handleBlur}
              InputProps={{
                disableUnderline: true,
                style: {
                  height: 32,
                  border: "none",
                  fontSize: isMobile ? "16px" : "20px",
                  fontWeight: 700,
                  color: "#1B3E61",
                },
              }}
              value={name}
              autoFocus
            />
          ) : (
            <>
              <Typography
                sx={{
                  fontSize: isMobile ? "16px" : "20px",
                  fontWeight: 700,
                  color: "#1B3E61",
                  flexGrow: 1,
                  width: "fit-content",
                  marginRight: "10px",
                }}
              >
                {name}
              </Typography>
              {isEditable && (
                <EditIcone 
                  height={"20px"} 
                  width={"20px"} 
                  className={"mr-5"} 
                  onClick={handleEditClick}
                  style={{ color: "rgba(27, 62, 97, 0.36)" }}
                />
              )}
            </>
          )}
        </div>
        {isEditable && (
          <Stack
            direction="row"
            sx={{
              backgroundColor: "#fff",
              padding: "6px 16px",
              border: "1px solid #919EAB33",
              borderRadius: "4px",
              marginRight: "40px",
              marginTop: "-3px",
              cursor: "pointer",
            }}
            alignItems="center"
            onClick={handleDelete}
          >
            <DeleteIcone height={"24px"} width={"24px"} className={"mr-5"} />
            <Typography fontWeight={500} fontSize={14}>
              Delete
            </Typography>
          </Stack>
        )}
      </Stack>
      {error && <p className="error">{errorText}</p>}
    </div>
  );
};

export default MilestoneHeader; 